import { Button, Drawer, Form, Input, Space } from "antd";
import { useEffect } from "react";
import { useAppSelector } from "../../../../app/store";
import SelectImgNameTitle from "../../../../components/common/SelectImgNameTitle";
import Loader from "../../../../components/ui/Loader";
import {
  useAddWorkStationMutation,
  useGetWorkStationDetailsQuery,
  useUpdateWorkStationMutation,
} from "../../../../features/org-setting/workStation/workStationApi";
import { useGetAllUsersQuery } from "../../../../features/portal/user/userApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";
import { ModalComponentProps } from "../../../../types";

export default function ManageWorkStation({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps<string>) {
  const [form] = Form.useForm();
  const { user } = useAppSelector((state) => state.auth);
  const {
    isLoading: isWorkStationLoading,
    isError: isWorkStationDetailsError,
    error: workStationDetailsError,
    data: workStationDetails,
  } = useGetWorkStationDetailsQuery(data || "", {
    skip: !data && type !== "UPDATE",
  });
  const {
    isError: isEmployeeError,
    error: employeeError,
    data: employeeData,
  } = useGetAllUsersQuery({
    params: {
      limit: 0,
      skip: 0,
      status: "active",
      company_id: user?.data?.company_id,
    },
  });
  const [addWorkStation, { isLoading, isError, isSuccess, error }] =
    useAddWorkStationMutation();
  const [
    updateWorkStation,
    {
      isLoading: isUpdateLoading,
      isError: isUpdateError,
      isSuccess: isUpdateSuccess,
      error: updateError,
    },
  ] = useUpdateWorkStationMutation();
  // error toast message
  useError(isError, error, "Work station added fail");
  useError(isUpdateError, updateError, "Work station updated fail");
  useError(isEmployeeError, employeeError, "Get employee data fail");
  useError(
    isWorkStationDetailsError,
    workStationDetailsError,
    "Get work station fail"
  );

  const onFinish = (values: object) => {
    const newValues = {
      ...values,
      business_id: user?.data?.company_id,
    };

    if (type === "UPDATE" && data) {
      return updateWorkStation({ body: newValues, id: data });
    }

    return addWorkStation(newValues);
  };

  useEffect(() => {
    if (Object.keys(workStationDetails?.data || {}) && type === "UPDATE") {
      const workStation = workStationDetails?.data;

      form.setFieldsValue({
        name: workStation?.name,
        address: workStation?.address,
        charge_in_center: workStation?.charge_in_center,
        abbreviation: workStation?.abbreviation,
        logo: workStation?.logo,
      });
    }
  }, [form, workStationDetails?.data, type]);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Work station added successfully");
      return handleClose();
    }
    if (isUpdateSuccess) {
      toast("success", "Work station updated successfully");
      return handleClose();
    }
  }, [handleClose, isSuccess, isUpdateSuccess]);

  return (
    <Drawer
      title={`${type === "UPDATE" ? "Edit" : "Add"} Work Station`}
      placement="right"
      width={480}
      className="right_site_drawer"
      onClose={handleClose}
      {...rest}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        {isWorkStationLoading ? (
          <Loader />
        ) : (
          <>
            {/* <Form.Item
              name="logo"
              label="Logo"
              className="mb-4"
              valuePropName="fileUrl"
            >
              <EmployeeFileUpload
                form={form}
                accept=".png, .jpg, .jpeg, .gif"
                name="logo"
                onChange={(url) =>
                  form.setFieldsValue({
                    logo: url,
                  })
                }
              />
            </Form.Item> */}
            <Form.Item
              name="name"
              label="Work station name"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter work station name",
                },
              ]}
            >
              <Input size="large" placeholder="Enter work station name" />
            </Form.Item>
            <Form.Item name="address" label="Address" className="mb-4">
              <Input size="large" placeholder="Enter address" />
            </Form.Item>
            <Form.Item
              name="charge_in_center"
              label="Charge-in Center"
              className="mb-4"
            >
              <SelectImgNameTitle
                placeholder="Select"
                data={employeeData?.data?.users}
              />
            </Form.Item>
            {/* <Form.Item
              name="abbreviation"
              label="Abbreviation"
              className="mb-4"
            >
              <Input size="large" placeholder="Ex: HRM" />
            </Form.Item> */}
          </>
        )}

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
            disabled={isLoading || isUpdateLoading}
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading || isUpdateLoading}
            disabled={isWorkStationLoading}
          >
            {type === "UPDATE" ? "Update" : "Create"}
          </Button>
        </Space>
      </Form>
    </Drawer>
  );
}
